import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WebflowObserver = () => {
  const location = useLocation();

  useEffect(() => {
    const initWebflow = () => {
      if (window.Webflow) {
        window.Webflow.destroy();
        window.Webflow.ready();
        if (window.Webflow.require) {
          window.Webflow.require('ix2').init();
        }
      }
    };

    // Small delay to ensure DOM is fully rendered by React
    const timer = setTimeout(() => {
      initWebflow();
    }, 100);
    
    // Scroll to top on route change
    window.scrollTo(0, 0);

    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

export default WebflowObserver;
